import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { UsersService } from 'src/app/private/services/users.service';
import { Router } from '@angular/router';
import { ApplicationService } from 'src/app/private/services/application.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { MoveToStudentComponent } from '../../components/admission/move-to-student/move-to-student.component';
import { BatchService } from 'src/app/private/services/batch.service';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { AddAdmissionComponent } from "../../components/admission/add-admission/add-admission.component";
import { FeeService } from 'src/app/private/services/fee-service.service';
import { HostelService } from 'src/app/private/services/hostel.service';
import { TransportService } from 'src/app/private/services/transport.service';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { BulkUpdateComponent } from "../../components/leads/bulk-update/bulk-update.component";
import { LeadEmailComponent } from "../../components/leads/lead-email/lead-email.component";
import { LeadCallComponent } from "../../components/leads/lead-call/lead-call.component";
import { WhatsappCommunicationComponent } from "../../components/leads/whatsapp-communication/whatsapp-communication.component";
import { BulkDeleteEnrollmentComponent } from "../../components/enrollment/bulk-delete-enrollment/bulk-delete-enrollment.component";
import { DeleteEnrollmentComponent } from "../../components/enrollment/delete-enrollment/delete-enrollment.component";
import { UploadDocumentsComponent } from "../../components/registration/upload-documents/upload-documents.component";
import { DeleteAdmissionComponent } from "../../components/admission/delete-admission/delete-admission.component";
import { BulkDeleteAdmissionComponent } from "../../components/admission/bulk-delete-admission/bulk-delete-admission.component";
import { CreateStudentProfileComponent } from "../../components/admission/create-student-profile/create-student-profile.component";
import { PdfFormGeneratorService } from '../../services/pdf-form-generator.service';
import { LeadService } from 'src/app/private/services/lead.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-admission',
  imports: [ToolBarComponent, SharedModule, MoveToStudentComponent, AddAdmissionComponent, BulkUpdateComponent, LeadEmailComponent, LeadCallComponent, WhatsappCommunicationComponent, UploadDocumentsComponent, DeleteAdmissionComponent, BulkDeleteAdmissionComponent, CreateStudentProfileComponent, ConfirmDialogModule],
  templateUrl: './admission.component.html',
  styleUrl: './admission.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class AdmissionComponent {
  selectedProducts: any[] = [];
  startDate: any = null;
  endDate: any = null;
  rows: number = 25;
  isOpenAddDialog: boolean = false;

  isBulkUpdate: boolean = false;
  isBulkCreateEnteranceExam: boolean = false;
  isBulkSendEmail: boolean = false;
  isBulkDeleteAdmissions: boolean = false;
  isCallLead: boolean = false;
  isEmailLead: boolean = false;
  leadDetails: any = null;
  loading: boolean = false;
  dataSource: any[] = [];
  displayedColumns: any[] = [];
  totalRecords: number = 0;
  editLeadData: any = null;
  isUploadDocument: boolean = false;
  isDeleteAdmission: boolean = false;
  isMoveToStudent: boolean = false;
  isBulkAction: boolean = false;
  isUpdateLeadSpace: boolean = false;
  isDeleteLeadSpace: boolean = false;
  isCreateStudentProfile: boolean = false;
  users: any[] = [];
  allCourses: any[] = [];
  academicYears: any[] = [];
  departments: any[] = [];
  batches: any[] = [];
  feeGroups: any[] = [];
  hostelCategories: any[] = [];
  transportCategories: any[] = [];
  scholarshipTypes: any[] = [];
  allLeadFeilds: any[] = [];


  filtersOptions: any[] = [];
  exportItems: any[] = [];
  tabItems: any[] = [];
  isWhatsappLead: boolean = false;
  isAdminUser: boolean = false;

  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Admissions',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdate = true;
          }
        },

        // {
        //   label: 'Create Enterance Exam',
        //   icon: 'pi pi-file-import',
        //   command: () => {
        //     this.isBulkCreateEnteranceExam = true;
        //   }
        // },
        {
          label: 'Send Email',
          icon: 'pi pi-envelope',
          command: () => {
            const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
            
            if (emailMode === 'none' || !emailMode) {
              this.confirmationService.confirm({
                message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
                header: 'Communication Medium Not Connected',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Connect Communication',
                rejectLabel: 'Cancel',
                acceptButtonStyleClass: 'p-button-warning',
                accept: () => {
                  this.confirmationService.close();
                  this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
              return;
            }
            
            this.isBulkSendEmail = true;
          }
        },
        {
          label: 'Delete Admissions',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isBulkDeleteAdmissions = true;
          }
        }
      ]
    }
  ];

  leadActionItems: any[] = [];


  constructor(
    private localStorage: LocalStorageService,
    private api: AdmissionService,
    private userApi: UsersService,
    private router: Router,
    private applicationService: ApplicationService,
    private messageService: MessageService,
    private registrationApi: RegistrationService,
    private batchService: BatchService,
    private academicYearService: AcademicYearService,
    private feeGroupService: FeeService,
    private hostelApi: HostelService,
    private transportApi: TransportService,
    private scholarshipApi: ScholarshipService,
    private pdfFormGenerator: PdfFormGeneratorService,
    private leadAApi: LeadService,
    private confirmationService: ConfirmationService
  ) {
    this.isAdminUser = this.localStorage.isAdminUser();
  }

  openAdmissionProfile(rowData: any) {
    this.router.navigate([`/main/admission/${rowData.admission_id}`]);
  }

  ngOnInit() {

    this.setFilterOptions();
    this.setFixedColumn();
    this.getAllUsers();
    this.getLeadsFields();
    this.setExportColumns();
    this.getAllCourses();
    this.getAllDepartments();
    this.getAllAcademicYears();
    this.getAllBatches();
    this.getAllFeeGroups();
    this.getAllHostelCategories();
    this.getAllTransportRoutes();
    this.getAllScholoarshipTypes();
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.allCourses = this.allCourses.map((course: any) => {
          course.course_id = parseInt(course.course_id);
          return course;
        }
        );
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departments = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearService.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYears = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.batchService.getAllBatches(param).subscribe({
      next: (data) => {
        this.batches = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }


  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllFeeGroups() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.feeGroupService.getAllActiveFeeGroups(param).subscribe({
      next: (res: any) => {
        this.feeGroups = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllHostelCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.hostelApi.getAllHostelCategories(param).subscribe({
      next: (data) => {
        this.hostelCategories = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllScholoarshipTypes() {

    console.log("Fetching Scholarship Types");
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.scholarshipApi.getAllScholarships(param).subscribe({
      next: (data) => {
        this.scholarshipTypes = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllTransportRoutes() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.transportApi.getAllTransports(param).subscribe({
      next: (data) => {
        this.transportCategories = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  loadAdmissions(event: any, searchValue?: string, searchAttribute?: string) {
    this.loading = true;

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"admission\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdminUser) {
      body.where['user_id'] = this.localStorage.getUserId();
    }

    if (searchValue && searchAttribute) {
      body.filter = {
        ...body.filter,
        [searchAttribute]: searchValue
      }
    }

    if (this.startDate && this.endDate) {
      body.startDate = this.startDate;
      body.endDate = this.endDate;
    }

    this.api.getAllAdmissionsWithCount(body).subscribe({
      next: (data) => {
        this.dataSource = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  setFilterOptions() {
    this.filtersOptions.push({ header: 'First Name', value: 'first_name', type: 'text' });
    this.filtersOptions.push({ header: 'Last Name', value: 'last_name', type: 'text' });
    this.filtersOptions.push({ header: 'Email', value: 'email', type: 'text' });
    this.filtersOptions.push({ header: 'Phone', value: 'phone', type: 'text' });
    this.filtersOptions.push({ header: 'Source', value: 'source', type: 'text' });
    this.filtersOptions.push({ header: 'Lead Status', value: 'lead_status', type: 'text' });
  }

  handleSearch(event: any) {
    console.log(event);
    this.loadAdmissions({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }

  fnHandleAddd() {
    this.isOpenAddDialog = true;
  }

  handleDateFilter(event: any) {
    // console.log('Date Filter:', event);
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.loadAdmissions({ first: 0, rows: this.rows }, undefined, undefined);
    } else {
      this.startDate = '';
      this.endDate = '';
      this.loadAdmissions({ first: 0, rows: this.rows });
    }
  }


  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.loadAdmissions({ first: 0, rows: this.rows });
  }

  setFixedColumn() {

    this.displayedColumns.push({
      field: 'admission_number',
      header: 'Admission Number',
      type: 'admission_number'
    });

    this.displayedColumns.push({
      field: 'contact_name',
      header: 'Contact Name',
      type: 'contact_name'
    });

    this.displayedColumns.push({
      field: 'Communicate',
      header: 'Communicate',
      type: 'communicate'
    });

      this.displayedColumns.push({
      field: 'student_profile',
      header: 'Student Profile',
      type: 'student_profile'
    });

    this.displayedColumns.push({
      field: 'academic_year',
      header: 'Academic Year',
      type: 'academic_year'
    });

    this.displayedColumns.push({
      field: 'Course',
      header: 'Course',
      type: 'course'
    });


    this.displayedColumns.push({
      field: 'createdAt',
      header: 'Added On',
      type: 'date'
    });


    this.displayedColumns.push({
      field: 'admission_status',
      header: 'Status',
      type: 'status'
    });


    // this.displayedColumns.push({
    //   field: 'admission_source',
    //   header: 'Source',
    //   type: 'source'
    // });

    this.displayedColumns.push({
      field: 'batch',
      header: 'Batch Name',
      type: 'batche'
    });

    this.displayedColumns.push({
      field: 'fee_category',
      header: 'Fee Category',
      type: 'fee_category'
    });

    this.displayedColumns.push({
      field: 'Total Fee',
      header: 'Total Fee',
      type: 'total_fee'
    });


    this.displayedColumns.push(
      {
        field: 'action',
        header: 'Actions',
        type: 'actions'
      }
    );

  }

  reloadDataTable() {
    this.selectedProducts = [];
    this.loadAdmissions({ first: 0, rows: this.rows });
  }

  handleWhatsappLead(event: any) {
    this.isWhatsappLead = true;
    this.leadDetails = event;
  }


  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }


  getStatusColor(status: string): string {
    switch (status) {
      case 'Completed': return '#1FAF38';     // Green
      case 'In Progress': return '#F0950C';   // Orange
      case 'Canceled': return '#D74843';      // Red
      case 'Pending': return '#F0950C';       // Orange
      case 'Under Review': return '#007BFF';  // Blue
      case 'Approved': return '#28A745';      // Bright Green
      case 'Rejected': return '#DC3545';      // Strong Red
      case 'Waitlisted': return '#FFC107';    // Yellow
      default: return '#6C757D';              // Neutral Gray
    }
  }

  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }

  handleCallLead(event: any) {
    this.isCallLead = true;
    this.leadDetails = event;
  }

  handleEmailLead(event: any) {
    const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
    
    if (emailMode === 'none' || !emailMode) {
      this.confirmationService.confirm({
        message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
        header: 'Communication Medium Not Connected',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Connect Communication',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => {
          this.confirmationService.close();
          this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }
    
    this.isEmailLead = true;
    this.leadDetails = event;
  }

  setLeadEditData(data: any) {
    this.editLeadData = data;
    this.updateLeadActionItems();
  }

  updateLeadActionItems() {
    const baseItems: any[] = [
      {
        label: 'Edit Admission',
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          this.router.navigate([`/main/admission/${this.editLeadData?.admission_id}`]);
        }
      },
      {
        label: 'Move to Student',
        icon: 'pi pi-fw pi-users',
        command: () => {
          this.isMoveToStudent = true;
        }
      }
    ];

    // Only add "Create Student Profile" if is_student_profile is false
    if (!this.editLeadData?.is_student_profile) {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        command: () => {
          this.isCreateStudentProfile = true;
        }
      });
    } else {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        disabled: true,
      });
    }

    baseItems.push(
      {
        label: 'Download Form',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadAdmissionForm(this.editLeadData);
        }
      },
      {
        label: 'Upload Documents',
        icon: 'pi pi-fw pi-upload',
        command: () => {
          this.isUploadDocument = true;
        }
      },
      {
        label: 'Delete Admission',
        icon: 'pi pi-fw pi-trash',
        command: () => {
          this.isDeleteAdmission = true
        },
        styleClass: 'delete-menu-item'
      } as any
    );

    this.leadActionItems = [
      {
        label: 'Options',
        items: baseItems
      }
    ];
  }

  removeSelectedProducts() {
    this.selectedProducts = [];
  }

  setExportColumns() {
    this.exportItems.push({ label: 'Prefix', value: 'prefix', checked: false });
    this.exportItems.push({ label: 'First Name', value: 'first_name', checked: false });
    this.exportItems.push({ label: 'Last Name', value: 'last_name', checked: false });
    this.exportItems.push({ label: 'Application Number', value: 'application_number', checked: false, type: 'application' });
    this.exportItems.push({ label: 'Contact Phone', value: 'phone', checked: false });
    this.exportItems.push({ label: 'Contact Email', value: 'email', checked: false });
    this.exportItems.push({ label: 'Source', value: 'source', checked: false });
    this.exportItems.push({ label: 'City', value: 'city', checked: false });
    this.exportItems.push({ label: 'State', value: 'state', checked: false });
    this.exportItems.push({ label: 'Country', value: 'country', checked: false });
    this.exportItems.push({ label: 'Date of Birth', value: 'date_of_birth', checked: false });
    this.exportItems.push({ label: 'Age', value: 'age', checked: false });
    this.exportItems.push({ label: 'Gender', value: 'gender', checked: false });
    this.exportItems.push({ label: 'Nationality', value: 'nationality', checked: false });
    this.exportItems.push({ label: 'Address', value: 'address', checked: false });
    this.exportItems.push({ label: 'Postal Code', value: 'postal_code', checked: false });
    this.exportItems.push({ label: 'Alternate Phone', value: 'alternate_phone', checked: false });
    this.exportItems.push({ label: 'Interested Course', value: 'interested_course', checked: false });
    this.exportItems.push({ label: 'Preferred Location', value: 'preferred_location', checked: false });
    this.exportItems.push({ label: 'Remarks', value: 'remarks', checked: false });
    this.exportItems.push({ label: 'Status', value: 'status', checked: false, type: 'application' });
    this.exportItems.push({ label: 'Document Status', value: 'document_status', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Name', value: 'guardian_name', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Contact', value: 'guardian_contact', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Previous Education', value: 'previous_education', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Course', value: 'preferred_course', checked: false, type: 'registration' });

  }


  export(selectedFields: any) {

    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        current_stage: 'application',
        campus_id: this.localStorage.getCampusId(),
      },
    };

    if (!this.isAdminUser) {
      param.where['user_id'] = this.localStorage.getUserId();
    }

    this.messageService.add({
      severity: 'info', summary: 'Exporting',
      detail: 'Exporting data, please wait...',
      sticky: true
    });

    this.leadAApi.getAllLeadList(param).subscribe({
      next: (data: any) => {

        const mappedData = data.map((lead: any) => {
          let row: any = {};

          selectedFields.forEach((field: any) => {
            if (field.type === 'dynamic_fields') {
              // Handle dynamic fields
              row[field.label] = lead.dynamic_fields?.[field.value] || '';
            } else if (field.type === 'registration') {
              if (field.value === 'preferred_course') {
                row[field.label] = lead.registration?.course?.name || '';
              } else {
                console.log("field", field)
                console.log("lead", lead.registration?.[field.value])
                console.log("lead", lead.registration)
                row[field.label] = lead.registration?.[field.value] || '';
              }
            } else if (field.type === 'application') {
              row[field.label] = lead.application_data?.[field.value] || '';
            }
            else {
              row[field.label] = lead[field.value] || '';
            }
          });

          return row;
        });

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

        // Save the file
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const date = new Date();
        const fileName = `Leads_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        saveAs(dataBlob, fileName);


        this.messageService.clear();

        this.exportItems.forEach((item) => {
          item.checked = false;
        }
        );

      },
      error: (e: any) => {

        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error exporting data' });

      },
    });
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'admission'
    };
    this.leadAApi.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields?.sort((a: any, b: any) => a.order - b.order) || [];
      },
      error: (e) => {
        console.error('Error fetching lead fields:', e);
      },
    });
  }

  downloadAdmissionForm(studentData?: any) {
    if (!studentData) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Data',
        detail: 'Please select a student to download the form.'
      });
      return;
    }

    this.messageService.add({
      severity: 'info',
      summary: 'Generating PDF',
      detail: 'Please wait while the PDF is being generated...',
      sticky: true
    });

    // Define form sections with data mapping
    const sections = this.pdfFormGenerator.createFormSectionsWithData(
      {
        'PERSONAL INFORMATION': [
          { label: 'Prefix', key: 'prefix' },
          { label: 'First Name', key: 'first_name' },
          { label: 'Last Name', key: 'last_name' },
          { label: 'Contact Email', key: 'email' },
          { label: 'Contact Number', key: 'phone' },
          { label: 'Alternate Number', key: 'alternate_phone' },
          { label: 'Date of Birth', key: 'date_of_birth' },
          { label: 'Age', key: 'age' },
          { label: 'Gender', key: 'gender' },
          { label: 'Nationality', key: 'nationality' }
        ],
        'ADDRESS INFORMATION': [
          { label: 'Address', key: 'address' },
          { label: 'City', key: 'city' },
          { label: 'State', key: 'state' },
          { label: 'Country', key: 'country' },
          { label: 'Postal Code', key: 'postal_code' }
        ],
        'ACADEMIC INFORMATION': [
          // { label: 'Query Type', key: 'query_type' },
          { label: 'Interested Course', key: 'course.name' },
          // { label: 'Preferred Location', key: 'preferred_location' },
          // { label: 'Previous Education', key: 'previous_education' },
          { label: 'Academic Year', key: 'academic_year.year_name' },
          // { label: 'Department', key: 'department.name' },
          { label: 'Batch', key: 'batche.batch_name' }
        ],
        'GUARDIAN INFORMATION': [
          { label: 'Guardian Name', key: 'guardian_name' },
          { label: 'Guardian Contact', key: 'guardian_contact' }
        ],
        'ADMISSION INFORMATION': [
          { label: 'Admission Number', key: 'admission_number' },
          { label: 'Admission Date', key: 'createdAt' },
          // { label: 'Admission Status', key: 'admission_data.status' },
          // { label: 'Fee Group', key: 'admission_data.fee_group.name' },
          // { label: 'Hostel Category', key: 'hostel_category.category_name' },
          // { label: 'Transport Route', key: 'admission_data.transport_route.route_name' },
          // { label: 'Scholarship Type', key: 'admission_data.scholarship.name' },
          // { label: 'Source', key: 'source' },
          { label: 'Remarks', key: 'remarks' }
        ]
      },
      studentData,
      this.allLeadFeilds
    );

    // Generate PDF using common service
    const studentName = `${studentData.fname || ''}_${studentData.lname || ''}`.trim() || 'Student';
    const date = new Date();
    const fileName = `Admission_Form_${studentName}_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}.pdf`;
    
    this.pdfFormGenerator.generatePDFForm({
      formTitle: 'ADMISSION FORM',
      fileName: fileName,
      sections: sections,
      showSignature: true,
      watermarkText: 'This is an official admission form. Please ensure all information is accurate and complete.',
      data: studentData
    });
  }
}

